import { PlanType } from 'enums';
import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import s from '../PlansPage.scss';

export interface NoTabsBannerProps {
  rootStore: RootStore;
  action(planType: PlanType): void;
}

const NoTabsBannerComp: React.FC<NoTabsBannerProps> = ({
  action,
  rootStore,
}) => {
  const { planType } = rootStore.appStore;
  // TODO: is isSecondUpgrade - for diffrent keys.

  const goToTab =
    planType === PlanType.Business ? PlanType.Website : PlanType.Business;

  const translationTags = {
    b: <b />,
    1: (
      <span
        data-testid='no-tabs-banner-button'
        className={s.noTabsBannerLink}
        onClick={() => action(goToTab)}
      />
    ),
  };

  // TODO: keys from Shane + isSecondUpgrade keys
  const translationKey =
    planType === PlanType.Business
      ? 'Advanced.DEMO.return_to_website'
      : planType === PlanType.Website
      ? 'Advanced.DEMO.return_to_business'
      : planType === PlanType.Enterprise
      ? 'Advanced.DEMO.return_to_business_from_enterprise'
      : ''; // fallback

  return (
    <Box
      minHeight='48px'
      width='100%'
      verticalAlign='middle'
      align='center'
      marginBottom='24px'
      marginTop='-36px'
    >
      <Box gap='3px'>
        <Text dataHook='no-tabs-banner' className={s.noTabsBannerContent}>
          <span>
            <Trans
              i18nKey={translationKey}
              components={translationTags}
            ></Trans>
          </span>
        </Text>
      </Box>
    </Box>
  );
};

export const NoTabsBanner = withInjectedRootStore(observer(NoTabsBannerComp));
